// Caps + spend are raw credits (1 credit = $0.01, pre-markup). Convert at the
// edge — shared by the Providers page and its panels so display formatting
// can't drift between them.

export const toUsd = (rawCredits: number) => rawCredits / 100;
export const toCredits = (usd: number) => Math.round(usd * 100);
export const fmtUsd = (rawCredits: number) => `$${toUsd(rawCredits).toFixed(2)}`;
export const fmtCap = (rawCredits: number) => (rawCredits > 0 ? fmtUsd(rawCredits) : '∞');
